<template>
  <div>
    <nav class="navbar navbar-inverse navbar-fixed-top">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
                  aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#"><img src="/static/img/only_logo_color.png"></a>
        </div>
        <div id="navbar" class="collapse navbar-collapse">
          <ul class="nav navbar-nav">
            <li><a v-link="'home'">Home</a></li>
            <li><a v-link="'configuration'">Configuraciones</a></li>
          </ul>        
          <div class="navbar-right" v-if="loading">
            <img src="/static/img/gears.gif">
          </div>
        </div><!--/.nav-collapse -->
      </div>
    </nav>
    <div class="container">
      <progress :percent.sync="myProgress.percent" :options="myProgress.options"> </progress>
      <router-view></router-view>
    </div>
    <alert :show.sync="error.show" :duration="2500" type="danger" width="400px" placement="top-right" dismissable>
      <span class="icon-info-circled alert-icon-float-left"></span>
      <strong>Error</strong>
      <p>{{error.message}}</p>
    </alert>
  </div>
</template>

<style>
  body {
    padding-top: 70px;
    padding-bottom: 30px;
  }

  .tituloHead {
    float: left;
    text-align: center;
    width: 100%;
  }

  .alert {
    z-index: 10000 !important;
  }
</style>

<script>
  import store from '../vuex/store'
  import progress from 'vue-progressbar/vue-progressbar.vue'
  import {alert} from 'vue-strap'
  import {
    getError,
    getLoading
  } from '../vuex/getters'

  export default {
    store,
    vuex: {
      getters: {
        error: getError,
        loading: getLoading
      }
    },
    components: {progress, alert},
    data () {
      return {
        myProgress: {
          percent: 0,
          options: {
            show: true,
            canSuccess: true,
            color: 'rgb(51, 102, 255)',
            failedColor: 'red',
            height: '3px'
          }
        }
      }
    },
    ready () {
      this.$progress.setHolder(this.myProgress)
    }
  }
</script>



/** WEBPACK FOOTER **
 ** App.vue?12a2bb28
 **/